import { RecommendedItem } from '../recommendation.types';
import { fetchJsonp } from '../utility/fetch';

type Params = {
  merchantId: string;
  domain: string;
  userId: string;
  specId: string;
  itemNum: number;
  productId?: string;
  categoryId?: string;
};

const buildSearchParams = (params: Params): URLSearchParams => {
  const { merchantId, userId, specId, itemNum, productId, categoryId } = params;
  const searchParams = new URLSearchParams();

  searchParams.set('merch', merchantId);
  searchParams.set('cookie', userId);
  searchParams.set('spec', specId);
  searchParams.set('num', itemNum.toString());

  if (productId != null) {
    searchParams.set('prod', productId);
  }
  if (categoryId != null) {
    searchParams.set('cat', categoryId);
  }

  return searchParams;
};

export const fetchRecommendations = async (params: Params): Promise<{ rqid: string; items: RecommendedItem[] }> => {
  if (!navigator.onLine) {
    throw new Error('Aborting external API endpoint call, due to browser being offline.');
  }

  const { domain } = params;

  const url = new URL(`https://${domain}/pycre5/jsonp/recommend`);
  url.search = buildSearchParams(params).toString();

  try {
    const response = await fetchJsonp(url.href);
    const json = await response.json();

    // レスポンスの json に含まれる items が [item, boolean] な構造になっているため、ここで取り出す
    return { rqid: json.rqid, items: json.items.map((i: [RecommendedItem, boolean]) => i[0]) };
  } catch (error) {
    /**
     * HTMLScriptElement.onerror で拾えるおおよそのレベルでハンドリングする
     * ref. https://ja.javascript.info/onload-onerror
     *
     * 起こりうるエラーとしては以下が考えられる:
     *
     * 1. 必須らしきパラメータ(e.g. merch) の typo: ステータス 503 が返却される
     * 2. 与えられたパラメータ(e.g. specId) に該当するレコメンド情報がない: ステータス 500 が返却される
     * 3. リクエスト先のリソース指定ミス: ステータス 404 が返却される
     * 4. リクエストタイムアウト: 規定時間(デフォルト 5000ms)以降にレスポンスが得られた場合ステータス 200 が返却される
     */
    console.error('Request to Silver Egg server failed, due to an unexpected error in the partner service.');
    throw error;
  }
};
